<template>
  <q-card class="loading-card q-pa-xl q-mb-lg">
    <div class="column items-center text-center">
      <div class="relative-position q-mb-md">
        <q-spinner color="white" size="80px" />
        <div class="pulse"></div>
      </div>

      <div class="text-h5 text-white q-mb-xs">
        {{ message1 }}
      </div>
      <div class="text-subtitle2 text-white opacity-80 q-mb-lg">
        {{ message2 }}<br />
        {{ message3 }}<br />
        {{ message4 }}
      </div>

      <q-separator dark spaced />

      <div v-if="startDate && duration" class="q-mt-md q-mb-lg">
        <div class="text-h6 text-white">{{ formattedDate }}</div>
        <div class="text-subtitle2 text-white opacity-90">{{ timeRange }}</div>
      </div>
    </div>
  </q-card>
</template>

<script setup lang="ts">
import { computed, defineProps } from 'vue'

const props = defineProps<{
  startDate?: Date
  duration?: number
}>()

// 🌍 Sprache anhand der URL bestimmen
const path = window.location.pathname
const lang = path.startsWith('/en/') ? 'en' : 'de'

// Dynamische Fehlermeldung
const message1 = computed(() =>
  lang === 'de'
    ? 'Zahlung wird verarbeitet'
    : 'Payment is processed'
)

const message2 = computed(() =>
  lang === 'de'
    ? 'Einen Moment Geduld…'
    : 'Just a moments patience...'
)

const message3 = computed(() =>
  lang === 'de'
    ? 'Termin wird erstellt und'
    : 'Appointment will be created and'
)

const message4 = computed(() =>
  lang === 'de'
    ? 'die Bestätigung wird gleich gesendet.'
    : 'confirmation will be sent right away.'
)

const formattedDate = computed(() => {
  if (!props.startDate) return ''
  return new Intl.DateTimeFormat('de-DE', {
    weekday: 'long',
    day: '2-digit',
    month: 'long',
    year: 'numeric'
  }).format(props.startDate)
})

const timeRange = computed(() => {
  if (!props.startDate || !props.duration) return ''
  const start = props.startDate
  const end = new Date(start.getTime() + props.duration * 60000)
  const fmt = new Intl.DateTimeFormat('de-DE', { hour: '2-digit', minute: '2-digit' })
  return `${fmt.format(start)} – ${fmt.format(end)} Uhr`
})
</script>

<style scoped>
.loading-card {
  background: linear-gradient(135deg, #1D1D1D, #1D1D1D);
  border-radius: 24px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
}
.relative-position {
  position: relative;
}
.pulse {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 90px;
  height: 90px;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  animation: pulse 1.8s ease-out infinite;
}
@keyframes pulse {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.8;
  }
  100% {
    transform: translate(-50%, -50%) scale(1.7);
    opacity: 0;
  }
}
.opacity-80 {
  opacity: 0.8;
}
.opacity-90 {
  opacity: 0.9;
}
</style>
